import React, {createContext, useContext, useEffect, useMemo, useState} from 'react';
import {useLocation} from 'react-router-dom';

type BreadcrumbOverride = {
    from: string;
    to: string;
    label?: React.ReactNode;
};

type BreadcrumbOverrideContextValue = {
    override?: BreadcrumbOverride;
    setOverride: (value?: BreadcrumbOverride) => void;
};

const BreadcrumbOverrideContext = createContext<BreadcrumbOverrideContextValue>({
    setOverride: () => undefined,
});

export const BreadcrumbOverrideProvider = (props: { children: React.ReactNode }) => {
    const { children } = props;
    const [override, setOverride] = useState<BreadcrumbOverride | undefined>(undefined);
    const location = useLocation();

    useEffect(() => {
        if (!override) {
            return;
        }

        if (location.pathname === override.to || location.pathname === override.from) {
            return;
        }

        setOverride(undefined);
    }, [location.pathname, override]);

    const value = useMemo(() => ({ override, setOverride }), [override]);

    return (
        <BreadcrumbOverrideContext.Provider value={value}>
            {children}
        </BreadcrumbOverrideContext.Provider>
    );
};

export const useBreadcrumbOverride = (): BreadcrumbOverrideContextValue => useContext(BreadcrumbOverrideContext);
